// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uy1etol0whU7iEEYPeFA{flex-direction:column;flex-grow:1;height:-webkit-max-content;height:max-content;margin-top:8px;margin-left:16px;display:flex;position:relative}.fLF_UnnwvXUH0ln7gabw{white-space:nowrap;padding:8px 8px 32px;position:-webkit-sticky;position:sticky;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uy1etol0whU7iEEYPeFA`,
	"moreBtn": `fLF_UnnwvXUH0ln7gabw`
};
export default ___CSS_LOADER_EXPORT___;
